"use client";

import * as React from "react";
import { ServerCrash } from "lucide-react";
import { ErrorPageLayout } from "./components/ErrorPageLayout";

interface ServerErrorPageProps {
  error?: Error;
  reset?: () => void;
}

export function ServerErrorPage({ error, reset }: ServerErrorPageProps) {
  React.useEffect(() => {
    if (error) {
      console.error("Server Error:", error);
    }
  }, [error]);

  return (
    <ErrorPageLayout
      code="500"
      title="Something Went Wrong"
      description="We encountered an unexpected error. Our team has been notified. Please try again or contact support if the problem persists."
      icon={ServerCrash}
      showRetry={true}
      onRetry={reset || (() => window.location.reload())}
      showGoBack={true}
    />
  );
}

export default ServerErrorPage;
